_.extend(Backbone.Validation.callbacks, {
  valid: function(view, attr, selector) {
    view.$('[' + selector + '~="' + attr + '"]').closest('.form-group').removeClass('has-error');
    view.$('[' + selector + '~="' + attr + '"]').siblings('.has-error').remove();
  },
  invalid: function(view, attr, error, selector) {
    view.$('[' + selector + '~="' + attr + '"]').siblings('.has-error').remove();
    view.$('[' + selector + '~="' + attr + '"]').closest('.form-group').addClass('has-error');

    if(view.$('[' + selector + '~="' + attr + '"]').is('input, textarea') && !view.$('[' + selector + '~="' + attr + '"]').is(':checkbox') && !view.$('[' + selector + '~="' + attr + '"]').hasClass('error-no-label')){
      $('<div id="error-'+attr+'" class="error-label has-error"><div><div class="error-text">' + error + '</div><div class="error-icon"><i class="fa fa-exclamation"></i></div></div></div>')
      .insertAfter(view.$('[' + selector + '~="' + attr + '"]'))
      .css('right', 3)
      .css('top', $('[' + selector + '~="' + attr + '"]').position().top + 3);
    }
  }
});

cv.FormBehavior = Marionette.Behavior.extend({
    // you can set default options
    // just like you can in your Backbone Models
    // they will be overriden if you pass in an option with the same key
    defaults: {
    },

    // behaviors have events that are bound to the views DOM
    events: {
      'keyup input' : 'keyupInput',
      'click .form-save' : 'saveForm',
      'click .form-validate' : 'validateForm',
      'click .button-remove-photo' : 'removePhoto',
      'click .form-expanded .form-sidebar h5' : 'collapseFormGroup',
      'click .form-collapsed' : 'expandFormGroup'
    },

    initialize: function(){
      // Set an ID for this form (to determine nested save)
      this.view._form_id = new Date().getUTCMilliseconds();

      // Hold the linked forms
      this.view._linked_forms = {};

      // Hold the merged form set values
      this.view._merge_attrs = {};

      // Create a fake model
      this.view._model_clone = new Backbone.DeepModel();

      // Check for an initial model, assign a generic one if we don't have it
      if(_.isUndefined(this.view.model)){
        this.view.model = new Backbone.DeepModel();
      }

      // Variable for notifications
      this.view._suppress_notifs = false;
      if(!_.isUndefined(this.options.suppress_notifications) && this.options.suppress_notifications == true){
        this.view._suppress_notifs = true;
      }

      // Variable for direct bindings
      this.view._direct_bind = false;
      if(!_.isUndefined(this.options.direct_bind) && this.options.direct_bind == true){
        this.view._direct_bind = true;

        this.listenTo(this.view._model_clone, 'change', function(model){
          this.view.model.set(model.attributes, { silent: true });
        }, this);
      }

      // Check for enabled unsaved changes
      if(!_.isUndefined(this.options.enable_unsaved_changes) && this.options.enable_unsaved_changes == true){
        cv.unsaved_views[this.view._form_id] = this.view;
      }

      // If we change this then set the unsaved changes flag true
      this.view._unsaved_changes = false;
      this.listenTo(this.view, 'form:changed', function(){
        this.view._unsaved_changes = true;
      }, this);

      // Refresh the current photo
      this.listenTo(this.view, 'form:refresh_photo', function(attr){
        // Fiddle with the BUTTONS
        if(this.view._model_clone.get(attr) == ''){
          this.view.$('#' + attr).closest('.form-group').find('.button-remove-photo').hide();
        }else{
          this.view.$('#' + attr).closest('.form-group').find('.button-remove-photo').css('display', 'inline-block').show();
        }

        // Replace the image
        var $replace = this.view.$('#' + attr).closest('.form-group-upload').find('.imgix-fluid').clone();

        // Default photo
        var photo_default = _.isUndefined($replace.attr('data-photo-default')) ? '' : $replace.attr('data-photo-default');

        var args;
        if ($replace.hasClass('logo-photo')) {
          args = {
            photo_path : this.view._model_clone.get(attr),
            photo_default : photo_default,
            transforms : {
              fit : 'unset'
            },
            url_only : true
          };
        } else {
          args = {
            photo_path : this.view._model_clone.get(attr),
            photo_default : photo_default,
            transforms : {
              fit : 'crop'
            },
            url_only : true
          };
        }

        $replace.attr('data-src', cv.photo(args));

        this.view.$('#' + attr).closest('.form-group').find('.imgix-fluid').replaceWith($replace);

        setTimeout(_.bind(function(){
          imgix.fluid(this.$el.get(0), {
            pixelStep: 5,
            autoInsertCSSBestPractices: true
          });
        }, this), 50);
      }, this);

      // Trigger to remove the current photo on the form
      this.listenTo(this.view, 'form:remove_photo', function(attr){
        var map = {};
        map[attr] = '';
        this.view._model_clone.set(map);

        this.view.trigger('form:refresh_photo', attr);
      }, this);

      // Trigger to remove the current photo on the form
      this.listenTo(this.view, 'form:saved', function(){
        if(this.view._suppress_notifs == false){
          // Scroll to top
          $('#content-view').scrollTop(0);

          vent.trigger('notif:success', 'Saved.');
        }
      }, this);

      // Trigger to remove the current photo on the form
      this.listenTo(this.view, 'form:has_errors', function(errors){
        console.log(errors);

        // Clear views array 
        this.views = []; 

        // Scroll to the first error
        if(!_.isUndefined(errors) && errors.length > 0){
          // If we are in a container then account for it
          if($('#' + errors[0]).parents('.container').last().length == 0){
            $('#content-view').animate({
              scrollTop : $('#content-view').scrollTop()
            }, 500);
          }else {
            $('#content-view').animate({
              scrollTop: $('#content-view').scrollTop() + $('#' + errors[0]).parents('.container').last().position().top
            }, 500);
          }
        }

        vent.trigger('notif:error', 'Please fix the errors on this form.');
      }, this);

      // Bind the save event, sync with server or model
      this.listenTo(this.view, 'form:save', this.save, this);

      // Bind the validate event, just validate the model rules
      this.listenTo(this.view, 'form:validate', this.validate, this);

      // Bind the link event (links forms)
      this.listenTo(this.view, 'form:link', this.linkForm, this);
      this.listenTo(this.view, 'form:unlink', this.unlinkForm, this);

      // Set a specific value on the form
      this.listenTo(this.view, 'form:set', this.setForm, this);

      // Reset the form to the original state
      this.listenTo(this.view, 'form:reset', this.resetForm, this);
      this.listenTo(this.view, 'form:rebind_datepicker', this.bindDatePicker, this);

      // Bind the unsaved changes trigger
      this.view.onHasUnsavedChanges = this.hasUnsavedChanges.bind(this);

      // Expose some save handlers
      this.view.onSaveForm = this.save.bind(this);

      this.views = [];

      console.log('FormBehavior initialized.');
    },

    hasUnsavedChanges: function(){
      // Loop through and figure out if there are unsaved changes
      this.views = [];
      this.recurseViews(this.view);
      var unsaved_changes = false;
      _.each(this.views, function(view){
        if(view._unsaved_changes == true){
          unsaved_changes = true;
        }
      }, this);
      return unsaved_changes;
    },

    keyupInput: function(e){
      e.preventDefault();
      
      // If we don't hit enter, then do nothing
      if (e.keyCode != 13) return;
      
      // Check for submit on enter class
      if($(e.currentTarget).hasClass('form-submit-enter')){
        // Trigger change event
        $(e.currentTarget).change();

        // Trigger submit
        this.view.trigger('form:save');
      }
    },

    // A way to force a value onto the cloned model
    setForm: function(attr, value){
      console.log('Setting form: ', attr);

      // Unset the attribute on the clone
      this.view._model_clone.unset(attr, { silent : true });

      // Unset the attribute in the merged array
      if(_.has(this.view._merge_attrs, attr)){
        delete this.view._merge_attrs[attr];
      }

      // Set the new value on the model
      this.view._model_clone.set(attr, value);

      // Set the value into the merge attr array for saving if it doesn't exist in the cloned model
      // If it does exist we don't want to merge over some old value
      this.view._merge_attrs[attr] = value;

      // Set unsaved changes flag
      this.view._unsaved_changes = true;
    },

    expandFormGroup: function(e){
      e.preventDefault();

      var $elem = $(e.currentTarget);
      $elem.removeClass('form-collapsed');
      $elem.addClass('form-expanded');
      $elem.find('.form-widebar').addClass('form-widebar-hidden');
      setTimeout(function(){
        $elem.find('.form-widebar').removeClass('form-widebar-hidden');
      }, 10);
    },

    collapseFormGroup: function(e){
      e.preventDefault();

      var $elem = $(e.currentTarget).parents('.form-expanded');
      $elem.removeClass('form-expanded');
      $elem.addClass('form-collapsed');
    },

    removePhoto: function(e){
      e.preventDefault();

      this.view.trigger('form:remove_photo', $(e.currentTarget).data('id'));
    },

    resetForm: function(){
      console.log('Resetting form...' + this.view._form_id);
      console.log(this.view.model.toJSON());

      // Bind the validations
      this.view._model_clone.set(this.view.model.toJSON());
      Backbone.Validation.bind(this.view, this.view._model_clone);

      // Reset unsaved form flag IF we have no pending merge attributes inside
      // This is a weird use case when we force set a value and perhaps reset async
      if(_.size(this.view._merge_attrs) == 0){
        this.view._unsaved_changes = false;
      }

      this.refreshPhotos();
      this.bindDatePicker();
    },

    bindDatePicker: function(){
      _.each(this.view.$('.form-group-datepicker'), function(item){
        var id = $(item).find('.form-group-datepicker__input').attr('id');
        var timezone = $(item).find('input#timezone').val();
        var default_date = $(item).find('input#default_date').val();
        if(timezone == ''){
          timezone = 'UTC';
        }
        var static = $(item).data('static');
        if(static === ''){
          static = true;
        }
        $(item).find('.form-group-datepicker__input').flatpickr({
          enableTime: true,
          altFormat : 'M j, Y h:i K',
          altInput : true,
          defaultDate : _.isUndefined(this.view._model_clone.attributes[id]) || !moment.utc(this.view._model_clone.attributes[id] ).isValid() ? default_date : moment.utc(this.view._model_clone.attributes[id] + 'Z').tz(timezone).format('YYYY-MM-DD HH:mm:ss'),
          dateFormat: 'Y-m-d H:i:S',
          static : static,
          onChange: _.bind(function (selectedDates, dateStr, instance) {
            this.view.trigger('form:set', id, moment.tz(dateStr, 'YYYY-MM-DD HH:mm:ss', timezone).utc().format('YYYY-MM-DD HH:mm:ss'));
          }, this),
          onReady: _.bind(function(dateObj, dateStr, instance) {
            var $cal = $(instance.calendarContainer);
            if ($cal.find('.flatpickr-clear').length < 1) {
              $cal.append('<div class="flatpickr-clear">Clear</div>');
              $cal.find('.flatpickr-clear').on('click', function() {
                instance.clear();
                instance.close();
              });
            }
          }, this)
        });
      }, this);
    },

    saveForm : function(e){
      e.preventDefault();

      // If this save button matches the current form, then trigger the save
      // This is to prevent a button on a lower nested form triggering a higher level formBehavior
      if(this.view._form_id == $(e.currentTarget).closest('.form-behavior').data('form-id')){
        console.log('Save button clicked on view:', this.view._form_id);
        this.view.trigger('form:save');
      }
    },

    validateForm : function(e){
      e.preventDefault();

      this.view.trigger('form:validate');
    },

    refreshPhotos: function(){
      // Refresh any photos
      _.each(this.view.validation, function(item, key, value){
        if(this.view.$('#' + key).closest('.form-group-upload').length > 0){
          this.view.trigger('form:refresh_photo', this.view.$('#' + key).attr('name'));
        }
      }, this);
    },

    linkForm: function(view){
      console.log('Linking form...');

      this.view._linked_forms[view._form_id] = view;
    },

    unlinkForm: function(view){
      console.log('Unlinking form...');

      if(_.isUndefined(view)){
        this.view._linked_forms = {};
      }else{
        if(_.has(this.view._linked_forms, view._form_id)){
          delete(this.view._linked_forms[view._form_id]);
        }
      }
    },

    validate: function(){
      console.log('----VALIDATING---------------------------------------------------');

      // Traverse and store into views
      this.recurseViews(this.view);

      // Reverse the array
      this.views = this.views.reverse();
      console.log('Validating views:', _.pluck(this.views, '_form_id'));

      var deferreds = [];
      _.each(this.views, function(subview){
        deferreds.push(subview._validate());
      });

      return $.when.apply(this, deferreds).then(_.bind(function(){
        console.log('Validation array: ', arguments);

        // If it's just one form
        if(!_.isArray(arguments[0])){
          if(arguments[1].length > 0){
            arguments[2].trigger('form:has_errors', arguments[1]);
            return false;
          }
        }else{
          for(i=0;i<=arguments.length-1;i++){
            if(arguments[i][1].length > 0){
              arguments[i][2].trigger('form:has_errors', arguments[i][1]);
              return false;
            }
          }
        }

        this.view.trigger('form:validated');
        return true;
      }, this));
    },

    recurseViews: function(view){
      this.views.push(view);
      _.each(view._linked_forms, function(subview){
        this.recurseViews(subview);
      }, this);
    },

    save: function(){
      this.view.$('.form-save').addClass('button-disabled');

      return $.when(this.validate()).then(_.bind(function(validated){
        if(!validated){
          this.view.$('.form-save').removeClass('button-disabled');
          return false;
        }

        console.log('----SAVING---------------------------------------------------');

        // Save each view
        _.each(this.views, function(view){
          var tmp = {};
          _.each(_.keys(view.validation), function(key){
            tmp[key] = view._model_clone.get(key);
          }, this);
    
          console.log('Merged attributes', view._merge_attrs);
          if(!_.isEmpty(view._merge_attrs)){
            tmp = _.extend(tmp, view._merge_attrs);
            view._merge_attrs = {};
          }
    
          view.model.set(tmp);
          if(!view.model.hasUrl()){
            // Reset unsaved changes flag
            this.view._unsaved_changes = false;
            view.trigger('form:saved', view);
          }
        }, this);

        if(this.view.model.hasUrl()){
          this.view.model
          .save()
          .done(_.bind(function(){
            // Reset unsaved changes flag
            this.view._unsaved_changes = false;

            _.each(this.views, function(subview){
              subview._unsaved_changes = false;
            });
            this.views = [];
            this.view.trigger('form:saved', this.view);
            this.view.$('.form-save').removeClass('button-disabled');

            this.resetForm();
          }, this))
          .fail(_.bind(function(){
            this.views = [];
            this.view.trigger('form:has_errors');
            this.view.$('.form-save').removeClass('button-disabled');
          }, this));
        }else{
          // Reset unsaved changes flag
          this.view._unsaved_changes = false;

          this.views = [];
          this.view.$('.form-save').removeClass('button-disabled');
        }

      }, this));
    },

    // Fired after injecting template into the view el (might not be attached to DOM), for multiple calls
    onDomRefresh: function(){
      console.log('Refreshing DOM...');

      // Refresh any photo upload elements
      this.refreshPhotos();
    },

    // Fired after attached to the DOM (can manipulate)
    onAttach: function(){
      console.log('----Attaching to DOM---------------------------------------------------');

      // Set a form ID
      this.view.$el.addClass('form-behavior');
      this.view.$el.attr('data-form-id', this.view._form_id);

      // Check if we are a sync model and respond accordingly
      if(this.view.model.hasUrl()){
        // If this is not a sync model, then ignore
        if(!_.isUndefined(this.view.model.isSynced)){
          if(this.view.model.isSynced() == false && !this.view.model.isNew()){
            this.view.$el.css('visibility', 'hidden');

            this.view.model.fetch({
              success: _.bind(function(){
                // Issue form reset
                this.resetForm();

                this.view.$el.css('visibility', 'visible');
              }, this),
              error: _.bind(function(){
                this.view.trigger('form:error_load');
              }, this),
              reset: true
            });
          }
        }
      }

      // Issue form reset
      this.resetForm();
    },

    onDestroy: function(){
      // Unbind the validation library
      Backbone.Validation.unbind(this.view);

      // Remove any unsaved changes keys
      if(_.has(cv.unsaved_views[this.view._form_id], this.view._form_id)) {
        delete(cv.unsaved_views[this.view._form_id]);
      }

      // Unbind the country/state fields
      if(this.view.$('#country').length > 0){
        this.view.$('#country').off();
      }
      if(this.view.$('#state').length > 0){
        this.view.$('#state').off();
      }

      // Destroy all linked forms
      this.view._linked_forms = {};
    }
});
